(() => {
 const DAY=86400000, KEY='izuro-free-shipping-start-v1';
 const remaining=(start,now)=>DAY-((Math.max(0,now-start))%DAY);
 const format=ms=>{const seconds=Math.ceil(ms/1000);return [Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].map(v=>String(v).padStart(2,'0')).join(':');};
 if(typeof module!=='undefined'&&module.exports)module.exports={remaining,format,DAY};
 if(typeof customElements==='undefined'||customElements.get('izuro-shipping-timer'))return;
 let fallbackStart=null;
 customElements.define('izuro-shipping-timer',class extends HTMLElement{
  connectedCallback(){
   if(Number(this.dataset.count)<1){this.hidden=true;return;}
   const now=Date.now();let start;
   try{const raw=localStorage.getItem(KEY);start=raw===null?NaN:Number(raw);if(!Number.isFinite(start)||start<=0||start>now){start=now;localStorage.setItem(KEY,String(start));}}catch{start=fallbackStart||now;fallbackStart=start;}
   this.start=start;this.hidden=false;this.clock=this.querySelector('[data-shipping-clock]');
   this.tick=()=>{if(this.clock)this.clock.textContent=format(remaining(this.start,Date.now()));};this.tick();this.interval=setInterval(this.tick,1000);
   this.onStorage=e=>{const value=Number(e.newValue);if(e.key===KEY&&e.newValue&&Number.isFinite(value)&&value>0&&value<=Date.now()){this.start=value;this.tick();}};
   window.addEventListener('storage',this.onStorage);
  }
  disconnectedCallback(){clearInterval(this.interval);window.removeEventListener('storage',this.onStorage);}
 });
})();
